import './index.css';
import { jsx } from 'react/jsx-runtime';
import { memo } from 'react';
import { genCssVarsFromSizesMap, getSizesMap } from './utils.js';
import { s as styles } from './styles-Cnlu5Ve-.js';

const VSpacingContainer = memo(({ children, ...spacingSizes }) => {
    const cssVars = genCssVarsFromSizesMap(getSizesMap(spacingSizes));
    return (jsx("div", { className: styles.vSpacingContainer, style: cssVars, children: children }));
});
VSpacingContainer.displayName = 'VSpacingContainer';

export { VSpacingContainer };
//# sourceMappingURL=VSpacingContainer.js.map
